<template>
  <div class="content">
    <iframe :src="src" style="width: 100%; height: 100vh"></iframe>
    <!-- 1 -->
  </div>
</template>

<script>
import {
  getConvertImagePath, //获取转换后的图片路径（pdf在线阅读）
} from "@/api/special/special";
import { ImagePreview } from "vant";
export default {
  data() {
    return {
      imageLIst: [],
      value: 0,
      index: 1,
      show: false,
      show2: false,
      src: "",
    };
  },
  props: {
    url: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    remark: {
      type: String,
      default: "",
    },
  },
  mounted() {
    this.src = "/static/html/web/viewer.html?file=" + this.url;
    // this.getImageList();
  },
  methods: {
    getImageList() {
      getConvertImagePath({ filePath: this.url }).then((res) => {
        this.imageLIst = res.data;
      });
    },

    showImg(e) {
      ImagePreview(["http://" + e]);
    },

    onChange(e) {
      let number = parseInt((e / 100) * this.imageLIst.length);
      this.$refs.Swipe.swipeTo(number);
    },
    swipeChange(e) {
      this.index = e + 1;
    },
    imgClick(e) {
      this.show2 = false;
      this.$refs.Swipe.swipeTo(e);
    },
  },
};
</script>

<style scoped lang='scss'>
div {
  box-sizing: border-box;
}
.content {
  position: relative;
  width: 100%;
  .top-box {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 40px;
    z-index: 99;
    .btn-box {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 12px;
      width: 30px;
      height: 30px;
    }
  }
  .my-swipe-box {
    width: 100%;
    height: calc(100vh - 120px);
    padding-top: 60px;
    background: #f2f2f2;
  }
  .van-swipe-item {
    display: flex;
    align-items: center;
    width: 100%;
    height: calc(100vh - 120px);
    padding-top: 60px;
    background: #f2f2f2;
    img {
      width: 100%;
    }
  }
  .plan-box {
    display: flex;
    justify-content: center;
    width: 100%;
    background: #f2f2f2;
    height: 60px;
    .plan {
      min-width: 60px;
      height: 30px;
      background: #555;
      padding: 0 10px;
      line-height: 30px;
      text-align: center;
      color: #f2f2f2;
      font-size: 14px;
      border-radius: 10px;
    }
  }
  .slider {
    padding: 20px 20px;
  }
  .introduce {
    width: 80%;
    min-height: 160px;
    max-height: 80vh;
    background: #fff;
    border-radius: 14px;
    padding: 14px 14px;
    .title {
      padding: 10px 0;
      font-size: 18px;
      color: #333;
      font-weight: 600;
      text-align: center;
    }
    .remark {
      padding-top: 10px;
      font-size: 14px;
      color: #777;
      max-height: calc(80vh - 100px);
      overflow: auto;
    }
  }
  .list {
    width: 100%;
    height: 100vh;
    background: #f2f2f2;
    padding-top: 60px;
    .list-item {
      width: 100%;
      height: calc(100vh - 70px);
      padding: 0 20px 10px 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      overflow: auto;
    }
  }
}
</style>